import { render, staticRenderFns } from "./departmenttable.vue?vue&type=template&id=1daaed0f"
import script from "./departmenttable.vue?vue&type=script&lang=js"
export * from "./departmenttable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports